export const Bio = {
  name: "Ayush Negi",
  roles: [
    "Programmer",
    "Software Engineer",
    "Backend Developer",
    "AI Enthusiast"
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/AYUSH-148/",
  resume:
    "https://drive.google.com/file/d/1LCS5RaOxcoExxwQUZtmxkKKEsG344lXR/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/ayush-negi-300209257/",
  insta: "https://www.instagram.com/aayush_007/",
  medium: "https://medium.com/@ayushpro111",
  leetcode: "https://leetcode.com/u/ayyush_007/",
};

export const leetcodeStats = {
  rating: 1933,
  badge: "Knight",
  globalRanking: "31,707",
  totalUsers: "875,878",
  contestsAttended: 16,
  profile: "https://leetcode.com/u/ayyush_007/",
};

export const certifications = [
  {
    id: 0,
    title: "Hacksagon Hackathon",
    issuer: "2nd Position",
    desc: "Secured 2nd position at Hacksagon, a national-level hackathon, for building an impactful project under time constraints.",
    link: "https://drive.google.com/file/d/1sTK5Wlr2JArYlakTKhozQ0bUI_uftpHg/view?usp=sharing",
  },
  {
    id: 1,
    title: "AWS Cloud Foundations and Core Infrastructure",
    issuer: "Coursera",
    desc: "Completed AWS cloud fundamentals covering core infrastructure services, compute, storage, networking, security, and the shared responsibility model.",
    link: "https://drive.google.com/file/d/1jm5IKZh5mnWsNEJH03NBYFX5uECn7sqK/view?usp=sharing",
  },
];

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Three.js",
        image:
          "https://s.yimg.com/zb/imgv1/f4a19ebc-4a07-38f1-b497-ea564ca643d1/t_500x300",
      },
      {
        name: "TypeScript",
        image:
          "https://imgs.search.brave.com/7mZ5KbtgXwUmyMVpggFAtFqWTh_aIk4F-p3edyjZwZE/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvY29tbW9ucy90/aHVtYi80LzRjL1R5/cGVzY3JpcHRfbG9n/b18yMDIwLnN2Zy8y/MjBweC1UeXBlc2Ny/aXB0X2xvZ29fMjAy/MC5zdmcucG5n",
      },
      {
        name: "Tailwind",
        image:
          "https://imgs.search.brave.com/nVyDpYrgvlKZUOIsHihVIipKzvjG4Rg7EXHWPPGy284/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvODJmYTczY2Fi/MDNjOWMxNTVmZTRl/ODgzMDMyYTU0MGI2/MGYxZTFkNzhkMWZl/YmQ5OWNkN2E3Mzcx/NWUzY2VkYi90YWls/d2luZGNzcy5jb20v",
      },
     
      {
        name: "Shadcn/ui",
        image:
          "https://seeklogo.com/images/S/shadcn-ui-logo-EF735EC0E5-seeklogo.com.png?v=638421451470000000",
      },    
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://imgs.search.brave.com/sFAukgJD-nbgqVp-6HA0hWnCXZ9QoE2guQ5ygS-ZowU/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvM2Y4YmU0NGQ3/ODQyMGE1YzhiZjZi/NTI1MzAzNDkzY2Rk/NmI2YzcyNGU1M2Fl/NjZmZDhlMWIyY2Y1/M2Q2ODExMS9leHBy/ZXNzanMuY29tLw",
      },
      {
        name: "Redis",
        image: "https://imgs.search.brave.com/0XydAktjaqN0nORmaggM2VJsY1Tx1nJiVNuih_WpnBU/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvYzAzNjQzNTY5/NTYzYTQyYzdmZmRl/ZTNiMzMwYWZhZTgw/MzQwN2JkMDg5NDcy/N2E3NzBkNDUxODIx/MWM3YWU5Mi9yZWRp/cy5pby8",
      },
      {
        name: "gRPC",
        image: "https://tse2.mm.bing.net/th/id/OIP.arCM2qXKl5Zfg7XtA0nrAAHaHa?pid=Api&P=0&h=180",
      },
      {
        name: "Socket.io",
        image: "https://s.yimg.com/zb/imgv1/a194d008-59d7-374c-b816-53c6e1174f9f/t_500x300",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "NextAuth",
        image:
          "https://imgs.search.brave.com/pBRtWwLyULAwZXQjHYcr5gfV6IV9yxW4ThVILv-0FA4/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvM2YyNmQ1NDI3/YmUxMDA3NDQyN2Mz/MDMyNTQ2ODU5OWFi/Y2RhNzc5YzkxZmI2/ZGE2YmUxZTczYzVl/NWU4MWNmNC9uZXh0/LWF1dGguanMub3Jn/Lw",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
{
  title: "Cloud Technologies",
  skills: [
    {
      name: "Cloud Networking",
      image: "https://www.svgrepo.com/show/375531/cloud-network.svg",
    },
    {
      name: "Linux Shell Scripting",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/bash/bash-original.svg",
    },
    {
      name: "AWS",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
    },
    {
      name: "Docker",
      image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
    },
    {
      name: "OpenTelemetry",
      image: "https://raw.githubusercontent.com/cncf/artwork/main/projects/opentelemetry/icon/color/opentelemetry-icon-color.svg",
    },
    {
      name: "ArgoCD",
      image: "https://raw.githubusercontent.com/cncf/artwork/main/projects/argo/icon/color/argo-icon-color.svg",
    },
  ],
},
{
  title: "Agentic AI & LLM Technologies",
  skills: [
    {
      name: "LangChain",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/langchain.svg",
    },
    {
      name: "LangGraph",
      image: "https://unpkg.com/@lobehub/icons-static-svg@latest/icons/langgraph.svg",
    },
    {
      name: "Model Context Protocol (MCP)",
      image: "https://unpkg.com/@lobehub/icons-static-svg@latest/icons/mcp.svg",
    },
    {
      name: "OpenAI",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/openai.svg",
    },
    {
      name: "Google Gemini",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/googlegemini.svg",
    },
    {
      name: "Claude",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/anthropic.svg",
    },
    {
      name: "Pinecone",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/pinecone.svg",
    },
    {
      name: "Neo4j",
      image: "https://cdn.jsdelivr.net/npm/simple-icons@v16/icons/neo4j.svg",
    },
    {
      name: "Vector Databases",
      image: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/outline/database.svg",
    },
    {
      name: "GraphRAG",
      image: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/outline/share.svg",
    },
    {
      name: "RAG",
      image: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/outline/search.svg",
    },
    {
      name: "AI Agents",
      image: "https://cdn.jsdelivr.net/npm/@tabler/icons/icons/outline/robot.svg",
    }
  ]
},
  {
    title: "Others",
    skills: [
      
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      
      {
        name: "Vercel",
        image:
          "https://imgs.search.brave.com/BNSQrXn2bmeJXUV454rdF3_0T8nAzszmcKdxq9LZbwQ/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvZDQ5YzljMTg4/MmJjMjJkYzEzMWZi/YmYyODM3ZjEyYzEw/MjY5OWFlM2I5YTY1/YmZhNTJlY2EwM2Iz/N2RhMWIxOC92ZXJj/ZWwuY29tLw",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://imgs.search.brave.com/6aVW64lywy3pCZ92XZZWT4x2dCJZAfThpPqiODIo7gI/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly9jb21t/dW5pdHkuY2hvY29s/YXRleS5vcmcvY29u/dGVudC9wYWNrYWdl/aW1hZ2VzL3Bvc3Rt/YW4uMTEuMS4wLnBu/Zw",
      },
      {
        name: "Canva",
        image:
          "https://imgs.search.brave.com/7cVOFDBkBYBy6vzfQl9pYittIldCaM3BYvXZWTTwF5o/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvZjg4ZDcxYmQ2/ZjkzMGEyNjUyNGJh/MjY0YjI4YmJmMWQz/YTcwNWIwOTFjNzUx/YmNlMWNmNmFkYTJl/NDA3YTdmMy93d3cu/Y2FudmEuY29tLw",
      },
    ],
  },
];

export const experiences = [
 {
    id: 0,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAflBMVEVHcEwTExoSExkSExkSExkSExkSEhkSExkSExkRAREPChQSKCUZfk8coGIfvnMSGhwYTj8eaVIbkFkhzXsgyXkebVYSExketm4gxnciNjISExkSExkXYkAZW0MAAANBQkXJycru7u/j4+Swr7FycnT///+WlpdSUlUSExkSExkmdrWqAAAAKnRSTlMAEGqy4aT/+yf/////////////////fv///8Xv////////////////hEMk4VbVAAABE0lEQVR4AXXSVaLDIBRFUWqnhXigRl7d5z/Bxy03NLp/IisKCN9kOpuHZtOJaLQAsATFO4tAKwy0Greg4KSUUNKnAJDNmKI4SbO88OVOZ0JM2EptjM7ytY8QE7HxuNW73U5n+yZuhCWSW7P7oiwaaEVFFuudR7VvYCVAaHaMkPkPQSj/dEDWBpYmIP3ToYVJA9XRFUUYwuPpfLnecPxhHPB4f3zbqxpVrmvMHr7rsUbI1Hg8Ph/cSRFWhAfNeKvxfqRBsDzsnTtfDq14g9U4xJ7t4gzveh3IfKuNzujW+kZaC9arkvu4zHC8Xx+P84nMijDbxBLAkVJwTYTrg8E+ZKSDxk1sl2xzza/etlpylX3ziv4HoiMqEvcaptMAAAAASUVORK5CYII=",
    role: "Software Engineer",
    company: "Coinswitch",
    date: "Jan 2026 - July 2026",
    desc: "Contributed to security and DevOps initiatives by developing Python-based automation and monitoring solutions to enforce repository security policies, streamline provisioning workflows, and generate real-time alerts for suspicious activities across Bitbucket infrastructure on AWS",
    skills: [
      "Golang","Java","AWS","gRPC","ArgoCD", "Kibana"
    ],
  },
  
  {
    id: 1,
    img: "https://imgs.search.brave.com/jAdjmqxG8C4dZ-LGtuR3NVHfWnU8_tG78FqxOX_qvKw/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvNTcxMzZhODg2/ZmNlZmM4NjkwNjNl/NDdkZTk2YTY5ZmMy/N2I3NWQ0NGNiMTc4/NDg0ZTRjM2U3M2Yz/MTEzNmZlYy9wcm9m/aW1hdGl4LmNvbS8",
    role: "Full Stack Next.js Intern",
    company: "Profimatix",
    date: "Oct 2024 - Dec 2024",
    desc: "Developed an AI Sales Copilot using Recall.ai, a transcriber, and AWS S3 for call data storage.",
    skills: [
      "Next.js","Typescript","Tailwind","AWS S3","Clerk", "Recall.AI"
    ],
  },
  {
    id: 2,
    img: "https://d502jbuhuh9wk.cloudfront.net/logos/63877d7ae4b0715e599aa5a1.png?v=19",
    role: "Web Developer Intern",
    company: "Cloud Counselage Pvt. Ltd.",
    date: "June 2024 - July 2024",
    desc: "Working on Cloud COunselage, created a Web App which stores the data of all the IT and management colleges in India using MERN",
    skills: [
      "React","Javascript","Tailwind","Scrapy","Render"
    ],
  },
  
 
];

export const education = [
  {
    id: 0,
    img: "https://imgs.search.brave.com/YRbW9et1as2nJdk2Q-CwUXyJ3e19eGd8Fr5WVRldCiI/rs:fit:500:0:0:0/g:ce/aHR0cHM6Ly91cGxv/YWQud2lraW1lZGlh/Lm9yZy93aWtpcGVk/aWEvZW4vdGh1bWIv/Yi9iMy9BdGFsX0Jp/aGFyaV9WYWpwYXll/ZV9JbmRpYW5fSW5z/dGl0dXRlX29mX0lu/Zm9ybWF0aW9uX1Rl/Y2hub2xvZ3lfYW5k/X01hbmFnZW1lbnQl/MkNfR3dhbGlvcl9s/b2dvLmpwZy81MTJw/eC1BdGFsX0JpaGFy/aV9WYWpwYXllZV9J/bmRpYW5fSW5zdGl0/dXRlX29mX0luZm9y/bWF0aW9uX1RlY2hu/b2xvZ3lfYW5kX01h/bmFnZW1lbnQlMkNf/R3dhbGlvcl9sb2dv/LmpwZw",
    school: "Indian Institute of Information Technlogy and Management, Gwalior",
    date: "Nov 2022 - July 2027",
    grade: "7.96 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Information Technology at Abv - Indian Institute of Information Technlogy and Management, Gwalior, Bhubaneswar. I have completed 4 semesters and have a CGPA of 7.55. I have learned  Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. ",
    degree: "Bachelor of Technology - BTech, Information Technology",
  },
  {
    id: 1,
    img: "https://imgs.search.brave.com/TT6LKXUW8GjrtBcl3ZbJa3iuIT17YFpLd4YLs8Irr2I/rs:fit:32:32:1:0/g:ce/aHR0cDovL2Zhdmlj/b25zLnNlYXJjaC5i/cmF2ZS5jb20vaWNv/bnMvMzVkYWUxNWM4/Zjg4YTk5ZjI3YmU5/YzVmMzM3NGE1Y2Zj/NmVkYThjM2E2M2E2/ZDMwYmExNDhhNTY4/NTIxMTczNS9kZXdh/bnB1YmxpY3NjaG9v/bG1lZXJ1dC5vcmcv",
    school: "Dewan Public School, Meerut",
    date: "Apr 2021 - Apr 2022",
    grade: "95%",
    desc: "I completed my class 12 high school education at Dewan Public School, Meerut, where I studied Science with Computer Science.",
    degree: "CBSE(XII), Science with Computer",
  },
];

export const projects = [
  {
    id: 7,
    title: "DB Explorer MCP",
    date: "Aug 2026",
    description:
      "A Model Context Protocol server that lets an AI coding assistant explore, query, and audit a relational database while making writes structurally impossible. The client's LLM authors the SQL; the server treats it as untrusted input and validates it against a sqlparse AST — single statement, SELECT only, no comments, keyword denylist — so a rejected query never reaches the driver, and every result set is row-capped. Exposes 7 FastMCP tools over stdio or streamable HTTP with OAuth 2.0: schema exploration, query execution, dialect-aware EXPLAIN plans, schema health checks, index suggestions, and migration review that parses up/down without executing it. Ships zero LLM dependencies and no API key — reasoning stays in the client — and works across PostgreSQL, MySQL, and SQLite through SQLAlchemy.",
    image:
      "https://opengraph.githubassets.com/1/AYUSH-148/DB-Explorer-MCP",
    tags: ["Python", "MCP", "FastMCP", "SQLAlchemy", "sqlparse", "PostgreSQL"],
    category: "AI tooling",
    github: "https://github.com/AYUSH-148/DB-Explorer-MCP",
    webapp: "",
  },

  {
    id: 6,
    title: "Self-Healing RAG – Hallucination-Reducing Agent",
    date: "July 2026",
    description:
      "A self-healing RAG agent built in LangGraph that self-critiques and retries its own answers against retrieved context, cutting the hallucination rate from 5.9% to 0% and raising correct abstention from 80% to 100% versus a plain-RAG baseline. Ships a reproducible LLM eval pipeline in CI (GitHub Actions) using a deterministic hallucination metric over a 34-example golden set that automatically fails the build on any regression. Includes a fail-closed structured-output layer for an 8B local model (Ollama) with Pydantic-validated verdicts, an auto-repair retry loop, and a guardrails gateway blocking prompt injection and PII leakage — fully local at zero API cost.",
    image:
      "https://opengraph.githubassets.com/1/AYUSH-148/Self-healing-Rag",
    tags: ["Python", "LangGraph", "Ollama", "Pydantic", "FastAPI"],
    category: "AI agent",
    github: "https://github.com/AYUSH-148/Self-healing-Rag",
    webapp: "",
  },

  {
    id: 0,
    title: "Relay",
    date: "June 2024 - Aug 2026",
    description:
      "A full-stack social platform (threads, organizations, likes, comments, shares) split into three TypeScript deployables — a Next.js 14 App Router web app, an Express 5 API, and a long-running Node worker — because Server-Sent Events and background loops cannot survive on serverless. Live notifications stream over SSE backed by Redis Pub/Sub, while Redis Streams consumer groups plus a transactional outbox guarantee at-least-once fan-out from MongoDB multi-document transactions. Ships networkless Clerk JWT verification, Zod-validated requests with rate limiting, request-id correlated JSON logs with /healthz /readyz /metrics, 79 Vitest + Supertest tests that need no live infrastructure, and a Docker image per service.",
    image:
      "https://opengraph.githubassets.com/1/AYUSH-148/Relay",
    tags: ["TypeScript", "Next.js 14", "Express", "Redis Streams", "MongoDB", "Clerk", "Docker"],
    category: "web app",
    github: "https://github.com/AYUSH-148/Relay",
    webapp: "https://relay-service-one.vercel.app/",
    member: [
      {
        name: "Ayush Negi",
        img: "https://avatars.githubusercontent.com/u/139256944?v=4",
        linkedin: "https://www.linkedin.com/in/ayush-negi-300209257/",
        github: "https://github.com/AYUSH-148/discord-clone",
      }, 
     
    ],
  },
 
    {
    id: 89,
    title: "MediFlow Assistant",
    date: "Jul 2025",
    description:
      "  MediFlow Assistant is a cutting-edge medical intelligence application that uses Google Gemini, Pinecone, Hugging Face, and Next.js to help users understand their medical reports. Upload PDFs or images → extract key medical information → ask questions → get accurate, personalized answers powered by Retrieval Augmented Generation (RAG).",
    image:
      "https://github.com/AYUSH-148/Assets-Images/blob/main/Screenshot%202025-11-20%20172648.png?raw=true",
    tags: ["RAG", "Pinecone", "Hugging Face", "Vercel AI SDK"],
    category: "AI powered web app",
    github: "hhttps://github.com/AYUSH-148/MediFlow-Assistant/e",
    webapp: "https://medi-flow-assistant.vercel.app",
    
  },
  {
    id: 3,
    title: "DNS Query Analyser",
    date: "June 2025",
    description:
      "Delivers actionable cybersecurity intelligence by continuously monitoring DNS traffic, enabling the immediate identification of malicious domains, anomalous client behavior, and critical query failures in real time.",
    image:
      "https://github.com/AYUSH-148/Assets-Images/blob/main/Screenshot%202025-08-14%20234211.png?raw=true",
    tags: ["Python","Scapy","Npcap","Flask","Docker"],
    category: "Computer Networks",
    github: "https://github.com/AYUSH-148/DNS-Query-Parser",
    webapp: "",
  },

  {
    id: 2,
    title: "PennyWise",
    date: "Dec 2023 - jan 2024",
    description:
      "A multi-account Finance‑Tracker web app supporting categorized transactions (e.g., food, utilities, subscriptions) with visualization charts—achieving >95% retained accuracy in category classification and reducing manual input time through AI-powered OCR bill scanning.",
    image:
      "https://github.com/AYUSH-148/Assets-Images/blob/main/Screenshot%202025-08-14%20233145.png?raw=true",
    tags: ["React Js", "MySql", "Prisma","Srcjet","Inngest", "Socket.io"],
    category: "web app",
    github: "https://github.com/AYUSH-148/Finance-Tracker",
    webapp: "https://finance-tracker-coral-theta.vercel.app/",
    member: [
      {
        name: "Ayush Negi",
        img: "https://avatars.githubusercontent.com/u/139256944?v=4",
        linkedin: "https://www.linkedin.com/in/ayush-negi-300209257/",
        github: "https://github.com/AYUSH-148/discord-clone",
      },
     
    ],
  },
 
 
 {
    id: 5,
    title: "Metro Route Finder",
    date: "July 2025",
    description:
      "Interactive metro navigation system leveraging Dijkstra's algorithm, displaying optimal routes, transfer locations, and fare estimations, enhancing user trip planning efficiency. ",
    image:
      "https://github.com/AYUSH-148/Assets-Images/blob/main/Screenshot%202025-08-15%20000119.png?raw=true",
    tags: ["Algorithms and Optimizations","Dijkstra's algorithm"],
    category: "DSA",
    github: "https://github.com/AYUSH-148/Metro-Route/",
    webapp: "https://themetroroute.vercel.app/",
  },
];

export const TimeLineData = [
  { year: 2022, text: "Started my journey" },
  { year: 2023, text: "Worked as a freelance developer" },
  { year: 2023, text: "Founded JavaScript Mastery ,CodeWithAntonio, CodeWithHarry" },
  { year: 2024, text: "Shared my projects with the world" },
];
